exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab{display:inline;margin-left:1vw}.total-header{font-family:Lato;font-weight:600;font-size:1.25vw;height:45px;overflow-wrap:break-word}.stats-block{background-color:var(--bootstrapgrey);padding-top:9px;padding-bottom:9px;margin-right:4px;border-radius:3px;box-shadow:0 .15rem .5rem rgba(0,0,0,.15)!important}.stats-header{font-family:Lato;font-weight:800;font-size:.8vw;height:45px;overflow-wrap:break-word}.user-stat{font-size:1.25vw}@media (max-width:1717px){.stats-header{height:65px}}@media (max-width:1438px){.user-stat{font-size:16px}}@media (max-width:1319px){.user-stat{font-size:14px}}@media (max-width:1238px){.stats-header{height:80px}}@media (max-width:992px){.stats-header{height:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36f1337d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/agents/StatusStats.vue
// module id = 738
// module chunks = 0